const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const isAnalyticsEnabled = Boolean (GA_MEASUREMENT_ID);

export const initGA = () => {
  if (!isAnalyticsEnabled) return;

  if (window.gtag) return;

  const script = document.createElement ('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild (script);

  window.dataLayer = window.dataLayer || [];

  window.gtag = function gtag () {
    window.dataLayer.push (arguments);
  };

  window.gtag ('js', new Date ());

  window.gtag ('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
  });
};

export const trackPageView = ({path, title}) => {
  if (!isAnalyticsEnabled || !window.gtag) return;

  window.gtag ('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const trackEvent = ({action, category, label, value}) => {
  if (!isAnalyticsEnabled || !window.gtag) return;

  window.gtag ('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};

